var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brush-sprites"},_vm._l((_vm.images),function(image){return _c('div',{key:image.id,staticClass:"brush",style:({ 'background-image': ("url(" + image + ")") })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }